'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notUndefined = notUndefined;
exports.number = number;
exports.func = func;
exports.funcWithArgs = funcWithArgs;
exports.funcWithOneArg = funcWithOneArg;
exports.funcWithoutArgs = funcWithoutArgs;
exports.bool = bool;
exports.object = object;
exports.string = string;
exports.valueOfEnum = valueOfEnum;
exports.uuid = uuid;
exports.checkArgument = checkArgument;
exports.checkState = checkState;
exports.array = array;

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function notUndefined(value) {
    if (value === undefined) {
        throw new Error('value must be defined!');
    }

    return value;
}

function number(value) {
    this.notUndefined(value);

    if (!(0, _isNumber2.default)(value)) {
        throw new Error('`' + value + '` must be number');
    }

    return value;
}

function func(value) {
    this.notUndefined(value);

    if (!(0, _isFunction2.default)(value)) {
        throw new Error('`' + value + '` must be function');
    }

    return value;
}

function funcWithArgs(value, argumentsCount) {
    this.func(value);
    this.number(argumentsCount);

    if (value.length !== argumentsCount) {
        throw new Error('\'' + value + '\' must be function with ' + argumentsCount + ' arguments');
    }

    return value;
}

function funcWithOneArg(value) {
    return this.funcWithArgs(value, 1);
}

function funcWithoutArgs(value) {
    return this.funcWithArgs(value, 0);
}

function bool(value) {
    this.notUndefined(value);

    if (!(0, _isBoolean2.default)(value)) {
        throw new Error('`' + value + '` must be boolean');
    }

    return value;
}

function object(value) {
    this.notUndefined(value);

    if (!(0, _isObject2.default)(value)) {
        throw new Error('`' + value + '` must be object');
    }

    return value;
}

function string(value) {
    this.notUndefined(value);

    if (!(0, _isString2.default)(value)) {
        throw new Error('`' + value + '` must be string');
    }

    return value;
}

function valueOfEnum(value, enumObject) {
    this.string(value);
    this.object(enumObject);

    if (!(value in enumObject)) {
        throw new Error('`' + value + '` must be value of enum ' + Object.keys(enumObject));
    }

    return value;
}

var UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function uuid(value) {
    this.string(value);

    if (!UUID_REGEX.test(value)) {
        throw new Error('\'' + value + '\' must be UUID');
    }

    return value;
}

/**
 * Ensures the truth of an expression involving one or more parameters to the calling method.
 * @throws Error if {@code expression} is false
 */
function checkArgument(expression, errorMessage) {
    if (!expression) {
        throw new Error(errorMessage ? errorMessage : 'wrong state');
    }
}

/**
 * Ensures the truth of an expression
 * @throws Error if {@code expression} is false
 */
function checkState(expression, errorMessage) {
    if (!expression) {
        throw new Error(errorMessage ? errorMessage : 'wrong state');
    }
}

function array(value) {
    this.notUndefined(value);

    if (!Array.isArray(value)) {
        throw new Error('`' + value + '` must be array');
    }

    return value;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/aurora-javascript-utils/dist/assert.js
// module id = 468
// module chunks = 118